<script>
// 设置服务商modal
import ServiceCompanySelect from "@/views/work-order/components/widgets/service-company-select";
import i18n from "@/i18n";
export default {
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.service-company')
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showModal: false,
      companyId: null
    }
  },
  methods: {
    changeCompany(value) {
      this.companyId = value
    },
    ok () {
      this.$emit('ok', this.companyId)
    },
    cancel () {
      this.$emit('cancel')
    },
  },
  components: {
    ServiceCompanySelect,
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        // console.log('showmodal:', val)
        this.showModal = val
      }
    },
    showModal(val) {
      if (!val) {
        this.$emit('cancel')
      }
    }
  }
}

</script>
<template>

  <b-modal v-model="showModal" id="setCompanyModal" hide-footer :title="title" header-class="p-3 bg-light"
           class="v-modal-custom" centered>

    <service-company-select @changed="changeCompany"></service-company-select>

    <div class="hstack gap-2 justify-content-end mt-5">
      <b-button type="button" variant="light" @click="cancel">
        {{ $t('base.cancel') }}
      </b-button>
      <b-button type="button" variant="success" @click="ok" :disabled="!companyId">
        {{ $t('base.done') }}
      </b-button>
    </div>

  </b-modal>


</template>
